<template>
  <div class="container">
    <h1>Hex To Decimal Explanation</h1>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: 'Learn How To Convert Hexadecimal to Decimal!',
      titleTemplate: '%s ← Cs Conversions',
      meta: [
        {
          name: 'description',
          content: 'Easily learn how to convert hexadecimal to decimal values!'
        }
      ]
    }
  }
}
</script>
